import React, {Fragment, PureComponent} from 'react';
import {translatedDescription} from 'app/utils/translations_helper';
import {hasRichDescription} from 'app/utils/richDescription';
import LootboxDetailsPrizes from 'app/components/shop/lootboxes/LootboxDetailsPrizes';
import LootInterface from 'app/interfaces/LootInterface';

interface Props {
    isLootbox?: boolean;
    loot?: LootInterface[];
    children?: React.ReactNode;
    item_type?: string;
    description?: string;
    description_langs?: { [key: string]: string };
}

export default class InventoryItemDescription extends PureComponent<Props> {
    render(): React.ReactNode {
        const {children, item_type, loot = []} = this.props;
        const isLootbox = this.props.isLootbox ?? ['lootbox', 'shard_lootbox'].includes(item_type || '');

        if (isLootbox) {
            return <Fragment>
                {children}
                <LootboxDetailsPrizes loot={loot} hideName/>
            </Fragment>;
        }

        if (hasRichDescription(item_type)) {
            return <div className="rich-description" dangerouslySetInnerHTML={{__html: translatedDescription(this.props)}}/>;
        }

        return <p>{translatedDescription(this.props)}</p>;
    }
}
